import React from 'react'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import { ArticleActions } from './articles/ArticleActions'

const BlogListItem = (props) => {
  const {
    title,
    author,
    date,
    last_updated,
    smallImage,
    mediumImage,
    excerpt,
    slug,
    readingTime,
  } = props
  const coverImageSources = [
    smallImage && smallImage.childImageSharp.fluid,
    {
      ...(mediumImage && mediumImage.childImageSharp.fluid),
      media: `(min-width: 479px)`,
    },
  ]
  return (
    <div className="blog-list-item">
      <h2 className="link-to-post">
        <Link to={`/${slug}`} state={{ fromBlogList: 'regular' }}>
          {title}
        </Link>
      </h2>
      {/*
      <p className="blog-date">
        {date}, Last update: {last_updated}
      </p>
      <p className="list-item-rt">{readingTime}</p>*/}

      <div className="information-section">
        <div className="blog-updated">
          <p>Published: {date}</p>
          <p>Last update: {last_updated}</p>
        </div>
        <p>{readingTime}</p>
      </div>
      <p className="blog-author">
        Author: <b>{author}</b>
      </p>
      {smallImage && mediumImage && (
        <Link
          to={`/${slug}`}
          state={{ fromBlogList: 'regular' }}
          aria-label={`Start reading ${title}`}
        >
          <div className="blog-preview-img">
            <Img fluid={coverImageSources} />
          </div>
        </Link>
      )}
      <p className="preview-para">{excerpt}</p>
      <p>
        <Link to={`/${slug}`} state={{ fromBlogList: 'regular' }}>
          Read more: {title}
        </Link>{' '}
        <span className="list-item-rt">({readingTime})</span>
        {/*<span>
          <p className="list-item-rt">{readingTime}</p>
        </span>*/}
      </p>
      <ArticleActions slug={slug} />
    </div>
  )
}

export { BlogListItem }
